
export function removeErrorField(field) {
	if (field.nextSibling !== undefined
		&& field.nextSibling !== null
		&& field.nextSibling.nodeType !== 3
		&& field.nextSibling.classList.contains('form__error')
	) {
		field.nextSibling.parentNode.removeChild(field.nextSibling);
		if (field.classList.contains('form__input_multiselect')) {
			field.parentNode.classList.remove('form__error-field');
		} else {
			field.classList.remove('form__error-field');
		}
	}
}

export function renderError(field, errorText) {
	const errorElem = document.createElement('div');

	removeErrorField(field);

	field.parentNode.insertBefore(errorElem, field.nextSibling);
	errorElem.innerText = errorText;
	errorElem.classList.add('form__error');
	if (field.classList.contains('form__input_multiselect')) {
		field.parentNode.classList.add('form__error-field');
	} else {
		field.classList.add('form__error-field');
	}
}
